<template>
  <v-container fluid class="px-0">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn @click="goToSales" icon>
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-alert
          v-if="form.status"
          type="info"
          outlined
          text
          border="left"
          dense
        >
          {{ form.status.description }}
        </v-alert>
        <v-card v-if="form.autorizado_por">
          <v-list-item>
            <v-list-item-icon>
              <v-icon v-if="form.aprovado" color="green"> mdi-check </v-icon>
              <v-icon v-else color="red">mdi-cancel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ form.aprovado ? "Autorizado por" : "Recusado por" }}
                <b>{{ form.autorizado_por.name }}</b>
              </v-list-item-title>
              <v-list-item-subtitle>
                às
                {{ formatDateTime(form.autorizado_as) }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-form @submit.prevent="saveSale">
          <ValidationObserver ref="form">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <v-card :loading="finding_sale" flat>
                      <v-card-title class="px-0">
                        <v-icon left>mdi-package-variant-closed</v-icon>
                        Produtos
                      </v-card-title>
                      <v-card-text class="px-0">
                        <SeletorProduto
                          v-if="!readonly"
                          @submit="addProduct($event)"
                        />

                        <v-divider></v-divider>

                        <div
                          v-for="(product, index) in sale_products"
                          :key="index"
                          class="mb-2"
                        >
                          <ProductCard
                            :product="product"
                            :index="index"
                            @remove="confirmProductDeletion"
                            @edit="handleEditProduct"
                            :readonly="readonly"
                          />
                        </div>

                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              <b>
                                Total
                              </b>
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <b>
                              {{ formatMoney(total) }}
                            </b>
                          </v-list-item-action>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="d-flex child-flex" cols="12" md="6">
                    <v-card filled flat>
                      <v-card-title class="px-0">
                        <v-icon left>mdi-account</v-icon>
                        Cliente
                      </v-card-title>
                      <v-card-subtitle class="px-0">
                        Responsável pelo pagamento.</v-card-subtitle
                      >
                      <v-card-text class="px-0">
                        <SeletorCliente
                          v-if="!readonly"
                          @submit="addCliente($event)"
                        />
                      </v-card-text>
                      <v-list-item
                        @click="handleClickClient"
                        v-if="form && form.cliente"
                        class="px-0"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ form.cliente.nome }}
                            <span v-if="form.cliente.deleted_at">
                              (Excluído)
                            </span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Cód {{ form.cliente.id }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="!readonly">
                            <span
                              :class="{
                                'green--text':
                                  form.cliente.credito_disponivel > 0,
                                'red--text':
                                  form.cliente.credito_disponivel <= 0
                              }"
                            >
                              {{ formatMoney(form.cliente.credito_disponivel) }}
                            </span>
                            disponível
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            @click="addCliente(null)"
                            icon
                            v-if="!readonly"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex child-flex" cols="12" md="6">
                    <v-card filled flat>
                      <v-card-title class="px-0">
                        <v-icon left>mdi-gavel</v-icon>
                        Comprador
                      </v-card-title>
                      <v-card-subtitle class="px-0">
                        Preencha quando um indivíduo comprar utilizando o
                        crediário de outro.
                      </v-card-subtitle>
                      <v-card-text class="px-0">
                        <v-text-field
                          v-model="form.comprador_nome"
                          label="Nome"
                          :readonly="readonly"
                        ></v-text-field>
                        <v-text-field
                          v-model="form.comprador_telefone"
                          label="Telefone"
                          v-mask="'(##) ####?#-####'"
                          placeholder="(00) 00000-0000"
                          type="tel"
                          :readonly="readonly"
                        ></v-text-field>
                        <v-textarea
                          v-model="form.comprador_observacoes"
                          label="Observações"
                          :readonly="readonly"
                        >
                        </v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex child-flex" cols="12" md="4">
                    <v-card flat>
                      <v-card-title class="px-0">
                        <v-icon left> mdi-cash-multiple </v-icon>
                        Forma de pagamento
                      </v-card-title>
                      <v-card-subtitle class="px-0"><br /></v-card-subtitle>
                      <v-card-text class="px-0">
                        <ValidationProvider
                          name="tipo_de_pagamento_id"
                          rules=""
                          v-slot="{ errors }"
                        >
                          <payment-type-picker
                            name="tipo_de_pagamento_id"
                            v-model="form.tipo_de_pagamento_id"
                            :error-messages="errors"
                            filled
                            :readonly="readonly"
                          />
                        </ValidationProvider>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card flat :loading="loading_cliente_addresses">
                      <v-card-title class="px-0">
                        <v-icon left>mdi-truck</v-icon> Entrega
                      </v-card-title>
                      <v-card-subtitle class="px-0"
                        >Endereço de entrega</v-card-subtitle
                      >
                      <v-card-text class="px-0">
                        <v-switch
                          label="O cliente vai retirar na loja"
                          v-model="form.retirar_no_local"
                          :readonly="readonly"
                        ></v-switch>
                        <div v-if="form.retirar_no_local == false">
                          <v-card outlined v-if="!readonly">
                            <v-subheader>ENDEREÇOS DO CLIENTE</v-subheader>
                            <AddressPicker
                              :client_id="form.cliente_id"
                              @change="fillAddress"
                              :readonly="readonly"
                              ref="addressPicker"
                            />
                          </v-card>

                          <v-row class="mt-5">
                            <v-col cols="12" md="6">
                              <ValidationProvider
                                name="cep_entrega"
                                v-slot="{ errors }"
                                lazy
                              >
                                <v-text-field
                                  name="cep_entrega"
                                  v-model="form.cep_entrega"
                                  label="CEP"
                                  v-mask="'#####-###'"
                                  :error-messages="errors"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6" md="4">
                              <ValidationProvider
                                name="estado_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.estado_entrega"
                                  label="Estado"
                                  counter="2"
                                  name="uf_entrega"
                                  :error-messages="errors"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                name="uf_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.cidade_entrega"
                                  label="Cidade"
                                  counter="45"
                                  :error-messages="errors"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="9">
                              <ValidationProvider
                                name="rua_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.rua_entrega"
                                  label="Rua / Avenida"
                                  counter="100"
                                  :error-messages="errors"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                name="numero_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.numero_entrega"
                                  label="Número"
                                  name="numero_entrega"
                                  counter="10"
                                  :error-messages="errors"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6">
                              <ValidationProvider
                                name="bairro_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.bairro_entrega"
                                  label="Bairro"
                                  :error-messages="errors"
                                  counter="45"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6">
                              <ValidationProvider
                                name="complemento_entrega"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="form.complemento_entrega"
                                  label="Complemento"
                                  :error-messages="errors"
                                  counter="45"
                                  :readonly="readonly"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </div>
                        <v-text-field
                          label="Informações adicionais (opcional)"
                          v-model="form.observacoes"
                          counter="255"
                          :readonly="readonly"
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-form>

        <confirm-action-dialog
          :confirm_action="confirm_produto_delete"
          @change="confirm_produto_delete = $event"
          @action="removeProduct"
          message="O produto será permanentemente removido do pedido"
        ></confirm-action-dialog>
      </v-card-text>
      <v-card-actions v-if="form.acoes">
        <v-spacer></v-spacer>
        <v-btn
          @click="saveSale()"
          x-large
          color="grey"
          dark
          elevation="0"
          class="mr-2"
          :loading="submitting"
          :disabled="checking_out_sale"
          v-if="form.acoes.pode_atualizar"
        >
          Salvar
        </v-btn>
        <v-btn
          v-if="form.acoes.pode_finalizar"
          @click="checkout()"
          x-large
          color="primary"
          :disabled="submitting"
          :loading="checking_out_sale"
        >
          <v-icon class="mr-3">mdi-cart</v-icon> Fechar pedido
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn
          :to="{ name: 'pedidos' }"
          x-large
          color="red"
          dark
          elevation="0"
          class="mr-2"
          :loading="submitting"
          :disabled="checking_out_sale"
        >
          Cancelar
        </v-btn>
        <v-btn
          @click="saveSale()"
          x-large
          color="grey"
          dark
          elevation="0"
          class="mr-2"
          :loading="submitting"
          :disabled="checking_out_sale"
        >
          Salvar
        </v-btn>
        <v-btn
          @click="checkout()"
          x-large
          color="primary"
          :disabled="submitting"
          :loading="checking_out_sale"
        >
          <v-icon class="mr-3">mdi-cart</v-icon> Finalizar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Ações </v-card-title>

          <v-list>
            <v-list-item-group>
              <v-list-item @click="confirmPrintSale" v-if="form.status">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="primary" left>mdi-printer</v-icon>
                    Imprimir Comprovante
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <template v-if="form.acoes && form.acoes.pode_aprovar">
                <v-list-item @click="confirmarAprovacao()" color="primary">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon color="primary" left>mdi-check</v-icon> Aprovar
                      venda
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="confirmarReprovacao()" color="red">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon color="red" left>mdi-close</v-icon> Reprovar venda
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-list>
            <v-list-item-group>
              <v-list-item
                @click="confirmarCancelarPedido()"
                color="red"
                v-if="form.acoes && form.acoes.pode_cancelar"
              >
                <v-list-item-content class="red--text">
                  <v-list-item-title> Cancelar pedido </v-list-item-title>
                  <v-list-item-subtitle>
                    Cancela o pedido e extorna o crédito para o cliente quando
                    comprado no crediário.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <confirm-print
      v-model="print_dialog"
      @action="printSale"
      :default_copies="2"
      message="Tem certeza que deseja imprimir o recibo desta venda?"
    />

    <ProductSaleForm ref="product_sale_form" @submit="changeProduct" />

    <ClienteDialogo ref="clienteDialogo" />
  </v-container>
</template>

<script>
import ConfirmActionDialog from "@/components/ConfirmActionDialog";
import {
  show as showPedido,
  update as updatePedido,
  store as storePedido,
  deleteProduto,
  finish as checkout,
  cancel as cancelarPedido,
  destroy as excluirPedido,
  approve as aprovarPedido
} from "@/services/sales";
import { index as indexProducts } from "@/services/products";
import { index as indexClients, show as showClient } from "@/services/clients";
import { listEstados, listDistritos } from "@/services/locals";
import { printSale } from "@/services/print";
import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";

import ConfirmPrint from "@/components/ConfirmPrint";
import PaymentTypePicker from "@/components/PaymentTypePicker";
import AddressPicker from "@/components/AddressPicker";
import ProductCard from "@/components/ProductCard";
import ProductSaleForm from "@/components/ProductSaleForm";
import SeletorProduto from "@/components/produtos/SeletorProduto";
import SeletorCliente from "@/components/clientes/SeletorCliente";
import ClienteDialogo from "@/components/clientes/ClienteDialogo.vue";

export default {
  components: {
    ConfirmPrint,
    ConfirmActionDialog,
    PaymentTypePicker,
    AddressPicker,
    ProductCard,
    ProductSaleForm,
    SeletorProduto,
    SeletorCliente,
    ClienteDialogo
  },
  mixins: [MoneyMixin, DateTimeMixin],
  data: () => ({
    address_dialog: false,
    products: [],
    total_products: 0,
    product_filter: "",
    actual_product_page: 1,
    submitting: false,
    loading_products: false,
    loading_more_products: false,
    sale_products: [],
    selected_product: null,
    confirm_produto_delete: false,
    produto_delete: null,
    loading_cliente_addresses: false,
    finding_sale: false,
    checking_out_sale: false,
    form: {
      retirar_no_local: false
    },
    address: {},
    print_dialog: false
  }),
  methods: {
    handleClickClient() {
      this.$refs.clienteDialogo.init(this.form.cliente);
    },
    changeProduct(payload, product_index) {
      this.sale_products = this.sale_products.map((product, index) => {
        if (index === product_index) {
          return { ...payload };
        }

        return product;
      });
    },
    handleEditProduct(product, index) {
      this.$refs.product_sale_form.init(product, index);
    },
    confirmPrintSale() {
      this.print_dialog = true;
    },
    async printSale(payload) {
      try {
        await printSale(this.form.id, payload);
        this.$store.commit("sendMessage", {
          text: "Recibo da venda foi enviado para impressão",
          color: "success"
        });
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível enviar o recibo desta venda para impressão",
          color: "error"
        });
      }
    },
    async checkout() {
      const validation = await this.$refs.form.validate();

      if (!validation) return;

      try {
        this.checking_out_sale = true;
        try {
          const pedido = {
            ...this.form,
            cliente_id: this.form.cliente_id || null,
            cliente_endereco_id: this.form.cliente_endereco_id,
            produtos: this.sale_products
          };
          const response = await checkout(pedido);
          this.fillResource(response.data);
          if (!pedido.id) {
            this.$router.replace({
              name: "edit_pedido",
              params: {
                numero: response.data.numero
              }
            });
          }
        } catch (error) {
          if (error.response.data.venda) {
            this.fillResource(error.response.data.venda);
            if (error.response.data.venda.id) {
              this.$router.replace({
                name: "edit_pedido",
                params: {
                  numero: error.response.data.venda.numero
                }
              });
            }
          }
          alert(error.response.data.message);
        } finally {
          this.checking_out_sale = false;
        }
      } catch (error) {
        console.log("error", error.response.data.message);
      }
    },
    fillAddress(address) {
      this.form = {
        ...this.form,
        cidade_entrega: address.cidade,
        bairro_entrega: address.bairro,
        cep_entrega: address.cep,
        estado_entrega: address.uf,
        rua_entrega: address.rua,
        numero_entrega: address.numero,
        complemento_entrega: address.complemento,
        cliente_endereco_id: address.id || null
      };
    },
    goToSales() {
      this.$router.go(-1);
    },
    async getProducts(filter) {
      const options = {
        sortBy: ["nome"],
        sortDesc: false,
        page: 1,
        itemsPerPage: 50
      };

      this.actual_product_page = 1;

      this.loading_products = true;
      try {
        const response = await indexProducts(options, filter);
        this.products = response.data;
        this.total_products = response.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading_products = false;
      }
    },
    async nextPage() {
      const page = this.actual_product_page + 1;

      const options = {
        sortBy: ["nome"],
        sortDesc: false,
        page,
        itemsPerPage: 50
      };

      this.loading_more_products = true;
      try {
        const response = await indexClients(options, this.product_filter);
        this.products = this.products.concat(response.data);
        this.total_products = response.total;
        this.actual_product_page = page;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading_more_products = false;
      }
    },
    addProduct(product) {
      const produto_id = product.id;
      delete product.id;
      this.sale_products.unshift({
        ...product,
        quantidade_produto: 1,
        produto_id
      });
    },
    addCliente(client) {
      if (!client) {
        this.form = {
          ...this.form,
          cliente_id: null,
          cliente: null
        };
        return;
      }
      this.form = {
        ...this.form,
        cliente_id: client.id,
        cliente: client
      };
    },
    confirmProductDeletion(index, produto) {
      this.confirm_produto_delete = true;
      this.produto_delete = {
        index,
        ...produto
      };
    },
    async removeProduct() {
      if (this.produto_delete.id != null) {
        try {
          await deleteProduto(this.produto_delete.id);
          this.sale_products = this.sale_products.filter(
            rec => rec.id != this.produto_delete.id
          );
        } catch (e) {
          this.$store.commit("sendMessage", {
            text: "Não foi possível remover este produto",
            color: "red"
          });
        } finally {
          this.confirm_produto_delete = false;
          this.produto_delete = null;
        }
      } else {
        this.sale_products.splice(this.produto_delete.index, 1);
        this.confirm_produto_delete = false;
        this.produto_delete = null;
      }
    },
    calcTotalProduct(sale_product) {
      return sale_product.quantidade_produto * sale_product.preco_venda;
    },
    fillResource(resource) {
      this.form = {
        ...this.form,
        ...resource
      };
      this.sale_products = resource.produtos;
      if (resource.cliente_endereco_id) {
        this.$refs.addressPicker.form_id = resource.cliente_endereco_id;
      }
    },
    async findPedido(numero_pedido = this.$route.params["numero"]) {
      this.finding_sale = true;
      try {
        const response = await showPedido(numero_pedido);

        this.fillResource(response.data);
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: e.response.data.error,
          color: "red"
        });
      } finally {
        this.finding_sale = false;
      }
    },
    async saveSale() {
      const validation = await this.$refs.form.validate();

      if (!validation) return;

      this.submitting = true;
      const pedido = {
        ...this.form,
        cliente_id: this.form.cliente_id || null,
        cliente_endereco_id: this.form.cliente_endereco_id,
        produtos: this.sale_products
      };

      try {
        const response = this.editMode
          ? await updatePedido(this.form.id, pedido)
          : await storePedido(pedido);

        this.$router.replace({
          name: "edit_pedido",
          params: {
            numero: response.data.numero
          }
        });

        this.fillResource(response.data);
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: e.response.data.message,
          color: "red"
        });
      } finally {
        this.submitting = false;
      }
    },
    async getCidades(estado) {
      this.loading_cidades = true;
      if (estado) {
        this.cidades = [];
        this.endereco.cidade_entrega = null;
        try {
          const response = await listDistritos(estado);
          this.cidades = response;
        } catch (e) {
          this.cidades = [];
        } finally {
          this.loading_cidades = false;
        }
      } else {
        this.cidades = [];
      }
    },
    confirmarAprovacao() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Aprovar pedido?",
        description: "Tem certeza que deseja aprovar pedido?",
        positive_action: () => this.aprovarVenda(true, this.form.id)
      });
    },
    confirmarReprovacao() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Reprovar pedido?",
        description: "Tem certeza que deseja reprovar o pedido?",
        positive_action: () => this.aprovarVenda(false, this.form.id)
      });
    },
    async aprovarVenda(aprovado, id) {
      const response = await aprovarPedido(id, { aprovado });

      this.fillResource(response.data);
    },
    confirmarCancelarPedido() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Cancelar pedido?",
        description: "",
        positive_action: () => this.cancelarPedido(this.form.id)
      });
    },
    async cancelarPedido(id) {
      const response = await cancelarPedido(id);
      if (response.data) {
        this.fillResource(response.data);
      } else {
        this.goToSales();
      }
    },
    confirmExcluirPedido() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Excluir pedido?",
        description: "A ação não poderá ser desfeita.",
        positive_action: () => this.excluirPedido(this.form.id)
      });
    },
    async excluirPedido(id) {
      try {
        await excluirPedido(id);
        this.$router.replace("/pedidos");
      } catch (error) {
        console.error(error);
        this.$store.commit("sendMessage", {
          text: "Falha ao excluir mensagem",
          color: "red"
        });
      }
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.params.numero, from.params.numero);
    },
    product_filter: _.debounce(async function(value) {
      await this.getProducts(value);
    }, 500),
    selected_product: function(value) {
      if (value == null) return;

      this.addProduct(value);
      this.$nextTick(() => {
        this.product_filter = "";
        this.selected_product = null;
      });
    }
  },
  computed: {
    status: function() {
      return this.form.status ? this.form.status.canonical : null;
    },
    readonly: function() {
      if (!this.form.status) return false;
      else {
        switch (this.form.status.canonical) {
          case "finalizado":
          case "cancelado":
          case "recusado":
          case "aprovado":
            return true;
          default:
            return false;
        }
      }
    },
    is_admin: function() {
      const user = this.$store.getters.getUser;

      return user.admin;
    },
    editMode: function() {
      return !!this.$route.params["numero"];
    },
    load_more_products: function() {
      return this.products.length < this.total_products;
    },
    total: function() {
      let total = 0;

      this.sale_products.forEach(sale_product => {
        total += this.calcTotalProduct(sale_product);
      });

      return total;
    },
    screenTitle: function() {
      return this.editMode ? this.$route.params["numero"] : "Novo pedido";
    },
    estados_brasil: function() {
      return listEstados();
    }
  },
  created() {
    if (this.editMode) this.findPedido();
  },
  beforeMount() {
    window.addEventListener("beforeunload", event => {
      if (!this.editMode) return;
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    });
  }
};
</script>
